module.exports = __webpack_public_path__ + "img/afam-gray.daa5265.png";